// removed by extract-text-webpack-plugin
module.exports = {"view-pane":"view-pane__view-pane","view-pane-gallery":"view-pane__view-pane-gallery","view-pane-related-views-collapse":"view-pane__view-pane-related-views-collapse","view-pane-related-views":"view-pane__view-pane-related-views","view-pane-specific":"view-pane__view-pane-specific","view-pane-specific-stretch":"view-pane__view-pane-specific-stretch","gallery-command":"view-pane__gallery-command"};


//////////////////
// WEBPACK FOOTER
// ./src/components/view-pane/view-pane.scss
// module id = 1235
// module chunks = 0